import { Button, Grid, Icon, Typography } from 'gu-ui-kit'
import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import useWriteToClipboard from 'utils/hooks/useWriteToClipboard'
import { useDispatch } from 'react-redux'
import styles from 'modules/Referral/ReferralClients/referral-clients.module.scss'
import { notificationShow } from 'modules/Notifications/actions'

export const LinkCell = ({ referral_link: { name, url } = {} }) => {
  const writeToClipboard = useWriteToClipboard()
  const dispatch = useDispatch()

  const onClickHandle = useCallback(
    (text) => {
      writeToClipboard(text)

      dispatch(
        notificationShow({
          type: 'success',
          message:
            'referral::referral_clients.notifications.success_copy_notification',
        }),
      )
    },
    [writeToClipboard],
  )
  return (
    <Grid direction={'column'} alignItems={'start'} gap={4}>
      <Typography variant={'Body-Forms-15'} color={'Label-Fifth'}>
        {name}
      </Typography>
      <Button
        className={styles['referral-clients__url']}
        onClick={() => onClickHandle(url)}
        type={'button'}
        variant={'ghost'}
        size={'s'}
        endIcon={<Icon name={'copy'} />}
        link
        noWrap
      >
        {url}
      </Button>
    </Grid>
  )
}
LinkCell.propTypes = {
  referral_link: PropTypes.object,
}
